import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FooterModule } from '../../../../../../../components/footer/footer.module';
import { HeaderModule } from '../../../../../../../components/header/header.module';
import { PhotoModule } from '../../../../../../../components/photo/photo.module';
import { ProcessProgressModule } from '../../../../../../../components/process-progress/process-progress.module';
import { PipesModule } from '../../../../../../../pipes/pipes.module';
import { DocumentPhotoRoutingModule } from './document-photo-routing.module';
import { DocumentPhotoPage } from './document-photo.page';

@NgModule({
  declarations: [
    DocumentPhotoPage
  ],
  imports: [
    CommonModule,
    HeaderModule,
    IonicModule,
    ProcessProgressModule,
    DocumentPhotoRoutingModule,
    FooterModule,
    PhotoModule,
    PipesModule
  ]
})
export class DocumentPhotoModule { }
